import { render } from "./K1Notification.vue?vue&type=template&id=74647328&scoped=true&ts=true"
import script from "./K1Notification.vue?vue&type=script&lang=ts"
export * from "./K1Notification.vue?vue&type=script&lang=ts"

import "./K1Notification.vue?vue&type=style&index=0&id=74647328&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74647328"]])

export default __exports__